import { useTranslation } from 'react-i18next';
import SocialMedia from '@components/social-media/SocialMedia';
import PhotoItem from '@pages/gallery/PhotoItem';
import { galleryItems } from '@pages/gallery/galleryItems';



const Gallery = () => {
	const { t } = useTranslation('web');

	return (
		<div className="app-page gallery-page">
			
			<h1>{t('pages.gallery.header')}</h1>

			<p>{t('pages.gallery.text')}</p>

			<div className='gallery-items'>

				{galleryItems.map((x,i) =>
					<PhotoItem item={x} key={`photo-item-${i}`} />)}

			</div>

			<SocialMedia />

		</div>
	);
};

export default Gallery;